// @ts-nocheck
import React from "react";
import { formatarData } from "../ExigenciaLinhaTempo";
import {
  Container,
  Concluido,
  Selo,
  Dados,
  AvisoEstadoCivil,
  Titulo,
  Passos,
  Consulados,
  BotaoPrincipal,
  BotaoSecundario,
  Rodape,
} from "./styles";

// Guia do cartão de cidadão e do passaporte (mesmo PDF anexado no e-mail de conclusão).
const LINK_GUIA =
  "https://drive.google.com/file/d/1VOKdpuLTvtYI_zZyfBqOjq7DoTf1gYu5/view?usp=sharing";

const cartao = [
  <>
    Agende em <b>agendamentos.mne.gov.pt</b> → Posto Consular → seu consulado
    → "Documento de identificação civil"
  </>,
  "Leve documento original com foto, o assento impresso em A4 e o requerimento do consulado",
  "Pague no local com cartão de débito e avise que também quer o passaporte",
];

const passaporte = [
  "Espere o consulado avisar que o cartão está pronto",
  'Agende de novo: "Documentos de viagem" → "Passaporte"',
  "Leve o cartão de cidadão, documento com foto e o requerimento",
];

const ListaPassos = ({ itens }) => (
  <ol>
    {itens.map((item, i) => (
      <li key={i}>
        <span>{i + 1}</span>
        <p>{item}</p>
      </li>
    ))}
  </ol>
);

// Card de conclusão: dados do assento, PDF da certidão (quando a automação
// enviou) e próximos passos para o cartão de cidadão e o passaporte.
export default function CardConclusao({ process }) {
  const nome = process?.applicant?.name;
  const concluidoEm = formatarData(process?.completion_date);

  return (
    <Container>
      <Concluido>
        <div className="topo">
          <strong>Processo concluído</strong>
          <Selo>Concluído</Selo>
        </div>
        <p>
          O registro de {nome} em Portugal foi concluído
          {concluidoEm ? ` em ${concluidoEm}` : ""}. Parabéns pela cidadania
          portuguesa!
        </p>
        <Dados>
          {process?.assento && (
            <>
              <span>Assento</span>
              <b>{process.assento}</b>
            </>
          )}
          {process?.type && (
            <>
              <span>Tipo</span>
              <b>{process.type}</b>
            </>
          )}
          {concluidoEm && (
            <>
              <span>Concluído em</span>
              <b>{concluidoEm}</b>
            </>
          )}
        </Dados>
        {process?.assento_pdf && (
          <BotaoPrincipal
            href={process.assento_pdf}
            target="_blank"
            rel="noopener noreferrer"
          >
            Baixar certidão do assento (PDF)
          </BotaoPrincipal>
        )}
      </Concluido>

      <AvisoEstadoCivil>
        <strong>Antes: atualize o estado civil (caso seja casado)</strong>
        <p>
          Para o cartão de cidadão e o passaporte saírem corretos, o casamento
          precisa estar transcrito em Portugal.
        </p>
      </AvisoEstadoCivil>

      <Titulo>Próximos passos</Titulo>

      <Passos>
        <div className="topo">
          <strong>1 · Cartão de cidadão</strong>
          <Selo>Primeiro</Selo>
        </div>
        <ListaPassos itens={cartao} />
      </Passos>

      <Passos>
        <div className="topo">
          <strong>2 · Passaporte</strong>
          <Selo className="neutro">Depois do cartão</Selo>
        </div>
        <ListaPassos itens={passaporte} />
      </Passos>

      <Consulados>
        <strong>Consulados no Brasil</strong>
        <p>
          São Paulo · Rio de Janeiro · Belo Horizonte · Porto Alegre. Outras
          cidades: contatos no Portal das Comunidades.
        </p>
      </Consulados>

      <BotaoSecundario href={LINK_GUIA} target="_blank" rel="noopener noreferrer">
        Baixar o guia completo (PDF)
      </BotaoSecundario>
      <Rodape>
        Sem despachante: o consulado pede que cada cidadão faça o próprio
        agendamento.
      </Rodape>
    </Container>
  );
}
